import { render, staticRenderFns } from "./pcStyle.vue?vue&type=template&id=4af92557&scoped=true"
import script from "./pcStyle.vue?vue&type=script&lang=js"
export * from "./pcStyle.vue?vue&type=script&lang=js"
import style0 from "./pcStyle.vue?vue&type=style&index=0&id=4af92557&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af92557",
  null
  
)

export default component.exports